import { useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { CreateClientEmployeeCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const CreateClientEmployee = () => {
  const navigate = useNavigate();

  const { clientId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.create,
  );

  const handleCreateClientEmployeeSuccess = () => {
    navigate(
      routes.portal.clients.client.clientEmployees.$buildPath({
        params: { clientId },
      }),
      {
        viewTransition: true,
      },
    );
  };

  return (
    <CreateClientEmployeeCard
      clientId={clientId}
      onCreateClientEmployeeSuccess={handleCreateClientEmployeeSuccess}
    />
  );
};
